import React, { Component } from "react";
import LoadingSpinner from "../../../../images/login/spinner-min.gif";

const LoggingInGIF = () => {
  return <div style={{ textAlign: "center", margin: "auto", marginTop: 100 }}><img width="50" src={LoadingSpinner} /></div>
}

export const PortalSelect = ({ props, allportals, setvals, is_mobile }) => {
  // get all the portals as per the url via ajax.

  let message = "Please select a portal from below";


  const handlePortalSelect = (s) => {
    if (s.active) {
      setvals(s)
    } else {
      alert("Coming Soon . . .")
    }
  }
  let disablestyle = { backgroundImage: "linear-gradient(135deg, #f34079 40%, #fc894d)" };
  return (
    <div className="system-select-container">
      <div className={`system-select-message ${is_mobile ? 'is_mobile' : ''}`}>
        {message}
      </div>
      <div className="system-select-buttons-content row">
        {allportals.map((s, idx) => {
          return (
            <div className={`system-select-buttons-container col-sm-12 ${is_mobile ? 'is_mobile' : ''}`} key={idx}>
              <div className={`system-select-button ${is_mobile ? 'is_mobile' : ''}`} style={!s.active ? disablestyle : {}} onClick={() => handlePortalSelect(s)}>{s.label}</div>
            </div>
          )
        })}
        {allportals.length == 0 &&

          <LoggingInGIF />

        }
      </div>
    </div>
  )
}